<template>
    <div class="delivery-debts">
        <div class="delivery-debts-grid" v-loading="loading">
            <template v-for="(column, index) in debtColumns">
                <div :key="'header_' + index" class="header-cell">
                    {{ column.headerName }}
                </div>
            </template>
            <div style="display: none">
                &nbsp;
            </div>
            <template v-for="(debt, debtIndex) in debts">
                <template v-for="(column, columnIndex) in debtColumns">
                    <div
                        :key="debtIndex+ '_'+ columnIndex"
                        :class="column.fieldClass"
                        :title="debt[column.field]"
                    >
                        <template v-if="column.field === 'deal_id'">
                            <a :href="getDealLink(debt[column.field])" target="_blank" class="link">
                                {{ debt[column.field] }}
                            </a>
                        </template>
                        <template v-else-if="column.field === 'debt'">
                            <span :class="{'red': debt.debt < 0}">
                                {{ formatFinance(debt[column.field]) }}
                            </span>
                        </template>
                        <template v-else-if="column.field === 'recieved_by_delivery'">
                            <auto-numeric
                                v-model="debt[column.field]"
                                :options="[numericOptionsGeneral, numericOptionsPositive]"
                                class="autonumeric"
                            />
                        </template>
                        <template v-else-if="column.field === 'save_button'">
                            <font-awesome-icon icon="save" class="action-icon" @click="saveRecievedByDelivery(debt.deal_id)" />
                        </template>
                        <template v-else>
                            {{ debt[column.field] }}
                        </template>
                    </div>
                </template>
            </template>
        </div>
        <div class="total" v-if="debts.length">
            <span class="total-info">
                Итого по {{ factoryName }}: {{ formatFinance(debtsTotalAmount) }} руб.
            </span>
        </div>
    </div>
</template>

<script>
import { formatFinance } from '@/common/utilities';
import '@/assets/styles/debts.scss';
import { faSave } from '@fortawesome/free-solid-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
import AutoNumeric from '@/components/autonumeric/VueAutonumeric';
import CloneForm from '@/components/salary/PayrollCloneForm';
import localReferences from '@/helpers/localReferences';
import moment from 'moment';

library.add(faSave);

export default {
    name: 'DeliveryDealsDebts',
    components: { AutoNumeric },
    props: {
        debts: {
            type: Array,
            default: () => []
        },
        factoryName: {
            type: String,
            default: ''
        },
        factoryId: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            debtColumns: [
                { headerName: 'Id сделки', field: 'deal_id', fieldClass: 'grid-cell' },
                { headerName: 'Дата замера', field: 'measurement_date', fieldClass: 'grid-cell' },
                { headerName: 'Дата монтажа', field: 'installation_date', fieldClass: 'grid-cell' },
                { headerName: 'Договор', field: 'contract', fieldClass: 'grid-cell cut-text ' },
                { headerName: 'Клиент', field: 'contact_name', fieldClass: 'grid-cell cut-text' },
                { headerName: 'Телефон клиента', field: 'contact_phone', fieldClass: 'grid-cell' },
                { headerName: 'Адрес', field: 'address', fieldClass: 'grid-cell cut-text ' },
                { headerName: 'Долг', field: 'debt', fieldClass: 'grid-cell text-right pr10' },
                { headerName: 'Получено доставкой', field: 'recieved_by_delivery', fieldClass: 'grid-cell text-right pr10' },
                { headerName: '', field: 'save_button', fieldClass: 'grid-cell text-right pr10 action-icon' }
            ],
            loading: false,
            numericOptionsGeneral: {
                digitGroupSeparator: ' ',
                decimalCharacter: ',',
                decimalPlaces: 0,
                decimalCharacterAlternative: '.',
                roundingMethod: 'U',
                isCancellable: true,
                modifyValueOnWheel: false
            },
            numericOptionsPositive: {
                minimumValue: '0',
                maximumValue: '9999999'
            }
        };
    },
    computed: {
        debtsTotalAmount() {
            return this.debts.reduce((sum, debt) => sum + (debt.debt > 0 ? +debt.debt : 0), 0);
        }
    },
    methods: {
        formatFinance,
        getDealLink(dealId) {
            return this.$router.resolve({ name: 'deal-card', params: { id: '' + dealId } }).href;
        },
        findDebt(dealId) {
            return this.debts.find(debt => debt.deal_id === +dealId);
        },
        async saveRecievedByDelivery(dealId) {
            const debt = this.findDebt(dealId);
            try {
                if (debt.recieved_by_delivery > 0) {
                    const income = {
                        operation_type_id: localReferences.operationTypes.deal,
                        operation_status_id: localReferences.operationStatuses.executed,
                        pay_type_id: localReferences.payTypesFull.cash,
                        detail_id: localReferences.incomeDetails.delivery,
                        received_by_type: localReferences.incomeRecievedByType.factory,
                        received_by_id: this.factoryId,
                        created_by_id: this.$store.state.auth.employerId,
                        received_from_type: 'contact',
                        received_from_id: debt.contact_id,
                        date: moment().format('DD.MM.YYYY'),
                        deal_id: debt.deal_id,
                        amount: debt.recieved_by_delivery,
                        comment: 'Приход от клиента'
                    };
                    this.income = await this.$store.dispatch('incomes/createDealIncome', { income });
                    this.actionAfterSave();
                    this.$emit('updateDeals', this.factoryId);
                    debt.debt = debt.debt - debt.recieved_by_delivery;
                    debt.recieved_by_delivery = 0;
                }
            } catch (e) {
                this.errors = JSON.parse(e.message);
                this.actionAfterSaveError();
            }
        },
        actionAfterSave() {
            this.$message({
                showClose: true,
                message: 'Приход сохранён',
                type: 'success',
                duration: 5000,
                customClass: this.alertClass()
            });
            this.$emit('closePopUp', false);
        },
        actionAfterSaveError() {
            this.$message({
                showClose: true,
                message: 'Приход не сохранён',
                type: 'error',
                duration: 5000,
                customClass: this.alertClass()
            });
        }
    }
};
</script>
